"use strict";

define('model/letter.tag',['./message.tag'], function (MessageTag) {
  var LetterTag = MessageTag.extend({}, {
    all: function all(templateType) {
      return this.createCollection('/rs/api/letter/replace/tags/:templateType').params({
        templateType: templateType || 'all'
      });
    }
  });
  return LetterTag;
});

